// extracted by mini-css-extract-plugin
export default {"phoneNumberSearchBar":"PhoneNumberSearchbar_phoneNumberSearchBar__sBcJY"};